import React from 'react';
import ContentLoader from 'react-content-loader';

import Container from '@/components/Container';
import {
  ContentWrapper,
  ImageContentWrapper,
} from '@/components/blocks/TopBlock';

const TopBlockLoader: React.FC = () => (
  <Container>
    <ContentWrapper>
      <ContentLoader
        speed={2}
        width={'100%'}
        height={'100%'}
        viewBox='0 0 456 345'
        backgroundColor='#f3f3f3'
        foregroundColor='#ecebeb'
        style={{ marginBottom: '3rem' }}
      >
        <rect x='0' y='53' rx='8' ry='8' width='436' height='48' />
        <rect x='0' y='273' rx='4' ry='4' width='456' height='16' />
        <rect x='0' y='0' rx='4' ry='4' width='80' height='20' />
        <rect x='0' y='301' rx='4' ry='4' width='366' height='16' />
        <rect x='0' y='329' rx='4' ry='4' width='396' height='16' />
        <rect x='0' y='125' rx='8' ry='8' width='456' height='48' />
        <rect x='0' y='197' rx='8' ry='8' width='346' height='48' />
      </ContentLoader>
      <ImageContentWrapper>
        <ContentLoader
          speed={2}
          width={'100%'}
          height={'100%'}
          viewBox='0 0 608 646'
          backgroundColor='#f3f3f3'
          foregroundColor='#ecebeb'
        >
          <path d='M 3.022 88.808 C -8.127 34.973 11.369 -1.332 64.93 0.64 l 469.972 38.777 c 41.294 3.407 73.062 37.864 73.037 79.217 l -0.276 428.144 c -0.026 41.919 -32.686 76.602 -74.606 79.23 L 214.652 645.96 c -58.474 -0.029 -102.019 -32.558 -112.669 -68.274 L 3.022 88.807 z' />
        </ContentLoader>
      </ImageContentWrapper>
    </ContentWrapper>
  </Container>
);

export default TopBlockLoader;
